const applyFilter = (data, filter) => {
  if (!filter || Object.keys(filter).length === 0) return data;

  return data.filter(item => matchesFilter(item, filter));
};

const matchesFilter = (item, filter) => {
  return Object.entries(filter).every(([key, value]) => {
    const itemValue = item?.[key];

    // Handle missing keys
    if (itemValue === undefined) return false;

    // Handle operator objects
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      const operators = Object.keys(value).filter(k => k.startsWith('$'));

      if (operators.length > 0) {
        return operators.every(op => {
          const operatorValue = value[op];

          switch (op) {
            case '$eq':
              return itemValue === operatorValue;
            case '$ne':
              return itemValue !== operatorValue;
            case '$in':
              return Array.isArray(operatorValue) && operatorValue.includes(itemValue);
            case '$nin':
              return Array.isArray(operatorValue) && !operatorValue.includes(itemValue);
            case '$gt':
              return itemValue > operatorValue;
            case '$gte':
              return itemValue >= operatorValue;
            case '$lt':
              return itemValue < operatorValue;
            case '$lte':
              return itemValue <= operatorValue;
            case '$contains':
              // Handle string contains
              if (typeof itemValue === 'string') {
                return itemValue.toLowerCase().includes(operatorValue.toLowerCase());
              }

              // Handle array of primitives
              if (Array.isArray(itemValue)) {
                // If operatorValue is an object (filter for array of objects)
                if (typeof operatorValue === 'object' && operatorValue !== null) {
                  return itemValue.some(elem => {
                    if (typeof elem === 'object' && elem !== null) {
                      return matchesFilter(elem, operatorValue);
                    }
                    return false;
                  });
                }
                // If operatorValue is a primitive (simple array contains)
                return itemValue.includes(operatorValue);
              }

              return false;

            case '$elemMatch':
              // Dedicated operator for array of objects matching
              if (Array.isArray(itemValue) && typeof operatorValue === 'object') {
                return itemValue.some(elem => {
                  if (typeof elem === 'object' && elem !== null) {
                    return matchesFilter(elem, operatorValue);
                  }
                  return false;
                });
              }
              return false;

            case '$regex':
              if (typeof itemValue === 'string') {
                const regex = typeof operatorValue === 'string' ? new RegExp(operatorValue, 'i') : operatorValue;
                return regex.test(itemValue);
              }
              return false;

            default:
              console.warn(`Unknown operator: ${op}`);
              return true;
          }
        });
      }

      // Handle nested objects recursively (when no operators present)
      if (typeof itemValue === 'object' && itemValue !== null && !Array.isArray(itemValue)) {
        return matchesFilter(itemValue, value);
      }

      return false;
    }

    // Handle arrays in item (for direct value matching)
    if (Array.isArray(itemValue)) {
      return itemValue.includes(value);
    }

    // Case-insensitive string match
    if (typeof itemValue === 'string' && typeof value === 'string') {
      return itemValue.toLowerCase() === value.toLowerCase();
    }

    // Default comparison
    return itemValue === value;
  });
};

// Dataset-specific accessors
export const getIncidents = ({ incidents, filter = {}, onIncidentClick }) => {
  const filteredIncidents = applyFilter(incidents, filter);

  const beautifiedIncidents = filteredIncidents.map(filteredIncident => ({
    id: filteredIncident.id,
    title: filteredIncident.title,
    status: filteredIncident.status,
    original: filteredIncident,
  }));

  return (
    <div className="flex flex-col">
      {beautifiedIncidents.length > 0 && (
        <span className="pb-2">{`Number of listed incidents: ${beautifiedIncidents.length}`}</span>
      )}
      <div className="space-y-2 cursor-pointer max-h-60 overflow-y-auto">
        {beautifiedIncidents.length > 0 ? (
          beautifiedIncidents.map(item => (
            <div key={item.id} className="border rounded-lg p-3" onClick={() => onIncidentClick?.(item.original)}>
              <h3 className="font-semibold text-lg">{item.title}</h3>
              <p className="text-sm text-muted">Status: {item.status}</p>
            </div>
          ))
        ) : (
          <span>No Incidents to show for your requirement</span>
        )}
      </div>
    </div>
  );
};

export const getResponders = ({ responders, filter = {}, onResponderClick }) => {
  const filteredResponders = applyFilter(responders, filter);

  const beautifiedResponders = filteredResponders.map(filteredResponder => ({
    id: filteredResponder.id,
    name: filteredResponder.displayName,
    presence: filteredResponder.presence,
    original: filteredResponder,
  }));

  return (
    <div className="flex flex-col">
      {beautifiedResponders.length > 0 && (
        <span className="pb-2">{`Number of listed responders: ${beautifiedResponders.length}`}</span>
      )}
      <div className="space-y-2 cursor-pointer max-h-60 overflow-y-auto">
        {beautifiedResponders.length > 0 ? (
          beautifiedResponders.map(item => (
            <div key={item.id} className="border rounded-lg p-3" onClick={() => onResponderClick?.(item.original)}>
              <h3 className="font-semibold text-lg">{item.name}</h3>
              <p className="text-sm text-muted">Status: {item.presence}</p>
            </div>
          ))
        ) : (
          <span>No responders currently matches your requirement.</span>
        )}
      </div>
    </div>
  );

  // return filteredResponders;
};
export const getChatHistory = ({ chatHistory, filter = {} }) => {
  const filteredChatHistory = applyFilter(chatHistory, filter);
  return filteredChatHistory;
};
